import { render, staticRenderFns } from "./DriverDetailsChatCard.vue?vue&type=template&id=1013c58e&scoped=true&"
import script from "./DriverDetailsChatCard.vue?vue&type=script&lang=js&"
export * from "./DriverDetailsChatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013c58e",
  null
  
)

export default component.exports